import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { PeriodService } from '../../../../../core/services/period.service';
import { SanctionService } from '../../../../../core/services/sanction.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule, NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-sanction-index',
    templateUrl: './sanction-index.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule,
        NgxPaginationModule,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        NgSelectComponent,
    ],
    styleUrls: ['./sanction-index.component.css']
})
export class SanctionIndexComponent {
  buttonsPermission :any|undefined;
  search_text=""
   structures:any[] =[]
   roles:any[] =[]
   data:any[] =[]
   sacs:any[] =[]
   periods:any[] =[]
   classrooms:any[] =[]
   selected_data:any;
   modalOption:any; 
   isDtInitialized:boolean = false
   is_active=null
   loading=false
   tag="admin-bvs-sanctions"
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
 
 
   constructor(
     private sanctionService:SanctionService,
     private periodService:PeriodService,
     private classroomService:ClassroomService,
     private sacService:StudentAyClassroomService,
     private toastrService:ToastrService,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {
     this.init()
     this.getActions()
   }
 
   init(){
     this.getAll()
      this.getClassrooms()
      this.getPeriods()
   }
 
  
 
   getAll(){
     this.sanctionService.getAll().subscribe((res:any)=>{
       this.data=res.data
       this.pg.p=0
       this.pg.total=res.data.length
       this.modalService.dismissAll()
     },
     (err:any)=>{
      AppErrorShow.showError("Gestion des sanctions",err)

     })
   }

   getClassrooms(){
     this.classroomService.getAll().subscribe((res:any)=>{
       this.classrooms=res.data
     },
     (err:any)=>{
      AppErrorShow.showError("Gestion des sanctions",err)

     })
   }

   getSacs(classroomId:any){
     this.sacService.getAll(classroomId).subscribe((res:any)=>{
       this.sacs=res.data
     },
     (err:any)=>{
      AppErrorShow.showError("Gestion des sanctions",err)

     })
   }
   getPeriods(){
     this.periodService.getAll().subscribe((res:any)=>{
       this.periods=res.data
     },
     (err:any)=>{
      AppErrorShow.showError("Gestion des sanctions",err)

     })
   }
 
   loadSacs(ev:any){
    this.getSacs(ev)
   }
 
   store(value:any){
     this.loading=true
     
     this.sanctionService.store(value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
 
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des sanctions",err)

     })
   }
   update(value:any){
     this.loading=true
 
     this.sanctionService.update(this.selected_data.id,value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des sanctions",err)

     })
   }
   delete(){
     if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.sanctionService.delete(this.selected_data.id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       console.log(err)
         AppErrorShow.showError("Gestion des sanctions",err)

     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.is_active
   }
   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalOption={centered:false,size:"lg"}
     this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }
 
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.sanctionService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des sanctions",err)

       })
   }
 
   getPage(event:any){
     this.pg.p=event
   }
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:false,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }
 
}
